import moment from 'moment'

export function getRelievingDate(user) {
  const offDutyHistory = user?.history?.filter(
    (h) => h?.status === 'Off Duty' && h?.updatedDate
  )
  if (offDutyHistory?.length > 0) {
    return moment(offDutyHistory[0]?.updatedDate).format('lll')
  }
  return moment(user?.tentativeRelievingDate).format('lll')
}
export function getReportingDate(user) {
  const startDutyHistory = user?.history?.filter(
    (h) => h?.status === 'Start Duty' && h?.updatedDate
  )
  if (startDutyHistory?.length > 0) {
    return moment(startDutyHistory[0]?.updatedDate)
  }
  return moment(user?.reportingDate)
}

export const getTransactionStatus = (date) => {
  const today = moment().startOf('day') // Ensure we are comparing the start of the day
  const expiry = moment(date).startOf('day') // Ensure expiry date is also at the start of the day
  const daysRemaining = expiry.diff(today, 'days')

  if (daysRemaining < 0) {
    return {
      status: 'expired', // Transaction has expired
      daysRemaining: 0,
      animate: false, // No animation since it's expired
    }
  }

  if (daysRemaining <= 10) {
    return {
      status: 'expiringSoon', // Transaction is expiring soon
      daysRemaining,
      animate: true, // Animate the red dot
    }
  }

  return {
    status: 'valid', // Transaction is still valid
    daysRemaining,
    animate: false, // No animation for valid transactions
  }
}
